import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Results from "@/pages/Results";
import MyReports from "@/pages/MyReports";
import AuthCallback from "@/pages/AuthCallback";
import Terms from "@/pages/Terms";
import Install from "@/pages/Install";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Privacy from "@/pages/Privacy";
import Showcase from "@/pages/Showcase";
import Analyzing from "@/pages/Analyzing";
import Account from "@/pages/Account";
import Watchlist from "@/pages/Watchlist";
import { AuthProvider } from "@/lib/auth";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/report/:id" element={<Results />} />
      <Route path="/my-reports" element={<MyReports />} />
      <Route path="/install" element={<Install />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/showcase" element={<Showcase />} />
      <Route path="/analyzing" element={<Analyzing />} />
      <Route path="/account" element={<Account />} />
      <Route path="/watchlist" element={<Watchlist />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
